import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { selectAttention } from '../redux/actions/fleetActions';

import { PillTrack, Pill } from '../components/Pill';
import { viewsFor, isActive, showPills } from './navItems';

/**
 * The view switcher.
 *
 * The design puts this in the content column above the page title, not in the
 * header — `showHeaderPills` is false and `showContentPills` is true for every
 * view except configuration, account and the district rollup.
 */
function PillNav({ userType, attentionCount, style = {} }) {
  const history = useHistory();
  const { pathname } = useLocation();

  if (!showPills(pathname)) return null;

  return (
    <PillTrack style={{ marginBottom: 24, ...style }}>
      {viewsFor(userType).map((view) => (
        <Pill
          key={view.key}
          on={isActive(pathname, view.path)}
          disabled={!view.ready}
          title={view.ready ? undefined : 'Not available yet'}
          count={view.key === 'overview' && attentionCount > 0 ? attentionCount : null}
          onClick={() => view.ready && history.push(view.path)}
        >
          {view.label}
        </Pill>
      ))}
    </PillTrack>
  );
}

PillNav.propTypes = {
  userType: PropTypes.object,
  attentionCount: PropTypes.number,
  style: PropTypes.object
};

const mapStateToProps = (state) => ({
  userType: state.auth.userType,
  attentionCount: selectAttention(state).length
});

export default connect(mapStateToProps)(PillNav);
